import type { FC, SVGProps } from "react";

const InfillionLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="currentColor"
    viewBox="0 0 1370.25 373.85"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <g>
      <path
        className="st0"
        d="M357.46,183.9c-.04-2.29-.11-4.56-.25-6.82l-82.97,3.52,82.4-10.75c-.22-2.16-.51-4.3-.82-6.43l-86.36,11.27,85.1-18.76c-.39-2.02-.82-4.02-1.28-6.01l-88.94,19.61,86.96-27.31c-.53-1.86-1.07-3.72-1.66-5.56l-90.82,28.52,88.06-36.35c-.65-1.7-1.3-3.4-2-5.08l-90.3,37.28c.68,1.6,1.27,3.25,1.82,4.92.02.07.05.14.08.21.52,1.58.96,3.19,1.36,4.81.05.19.1.37.14.56.36,1.5.66,3.01.91,4.54.05.31.09.61.14.92.21,1.4.42,2.81.54,4.24.04.42.04.86.06,1.28.09,1.3.19,2.6.2,3.92,0,.17.03.34.03.51,0,.38-.05.74-.06,1.11-.02,1.2-.1,2.38-.18,3.57-.05.65-.03,1.32-.1,1.97-.11,1.08-.32,2.13-.48,3.2-.11.76-.21,1.53-.35,2.29-.18.95-.39,1.89-.61,2.83-.2.86-.43,1.72-.66,2.56-.23.83-.42,1.67-.68,2.48-.3.95-.68,1.87-1.02,2.8-.26.7-.49,1.42-.77,2.11-.42,1.03-.9,2.02-1.36,3.02-.27.58-.54,1.16-.83,1.73-.55,1.09-1.12,2.16-1.72,3.21-.27.46-.55.91-.83,1.37-.69,1.13-1.38,2.27-2.14,3.36-.25.35-.52.68-.77,1.03-.84,1.16-1.67,2.34-2.59,3.44-.21.25-.45.48-.66.73-1,1.17-2.03,2.32-3.11,3.42-.16.16-.31.34-.47.51-1.17,1.16-2.41,2.25-3.66,3.33-.1.08-.19.18-.29.26-1.34,1.14-2.74,2.2-4.16,3.23-.02.02-.05.04-.07.05-1.46,1.05-2.96,2.02-4.51,2.95-.06.03-.12.07-.17.11-1.49.89-3.02,1.72-4.58,2.5-.15.07-.29.14-.44.21-1.49.72-2.99,1.4-4.54,2.01-.24.09-.48.17-.72.26-1.47.56-2.94,1.11-4.45,1.57-.33.1-.68.17-1.01.26-1.43.41-2.86.8-4.33,1.11-.43.09-.87.16-1.3.24-.83.16-1.68.26-2.53.39-.97.15-1.92.34-2.91.44-.11.01-.22.03-.33.04-.03,0-.06,0-.09,0v97.83c1.47-.06,2.93-.14,4.39-.24.97-.06,1.93-.14,2.9-.22,1.35-.11,2.7-.22,4.04-.36l-.69-16.16,2.08,15.98c4.21-.49,8.38-1.13,12.48-1.94l-2.55-19.58,4.24,19.25c4.04-.84,8-1.86,11.92-2.99l-5.01-22.74,6.97,22.18c3.83-1.16,7.59-2.46,11.3-3.88l-8.04-25.61,10.22,24.75c3.6-1.44,7.16-2.98,10.63-4.66l-11.62-28.14,13.98,26.93c3.36-1.7,6.66-3.5,9.88-5.41l-15.66-30.18,18.2,28.64c3.1-1.92,6.12-3.96,9.08-6.08l-20.17-31.74,22.84,29.84c2.83-2.12,5.56-4.35,8.24-6.64l-25.07-32.75,27.78,30.39c2.55-2.27,5.03-4.62,7.44-7.04l-30.3-33.15,33,30.31c2.26-2.4,4.47-4.85,6.59-7.38l-35.79-32.87,38.44,29.57c1.98-2.5,3.89-5.05,5.72-7.66l-41.45-31.89,44.03,28.13c1.69-2.56,3.3-5.17,4.85-7.83l-47.27-30.19,49.71,25.95c1.41-2.59,2.74-5.24,4.01-7.91l-53.07-27.71,55.22,22.95c1.14-2.6,2.21-5.23,3.22-7.91l-58.79-24.43,60.63,19.2c.87-2.58,1.68-5.19,2.42-7.82l-64.31-20.36,65.82,14.67c.62-2.54,1.18-5.09,1.67-7.67l-69.59-15.51,70.69,9.39c.38-2.46.68-4.95.95-7.45l-74.55-9.9,75.09,3.37c.16-2.37.26-4.76.31-7.16l-79-3.54,79.02-3.36Z"
      />
      <path
        className="st0"
        d="M254.52,160.9l86.81-45.06c-.74-1.54-1.54-3.04-2.33-4.56l-86.7,45c.79,1.51,1.55,3.04,2.22,4.61Z"
      />
      <path
        className="st0"
        d="M252.09,155.84l82.53-52.44c-.82-1.37-1.66-2.72-2.52-4.06l-82.46,52.4c.85,1.35,1.69,2.7,2.45,4.11Z"
      />
      <path
        className="st0"
        d="M249.2,151l77.65-59.44c-.86-1.2-1.73-2.4-2.62-3.58l-77.6,59.4c.89,1.18,1.76,2.38,2.57,3.62Z"
      />
      <path
        className="st0"
        d="M245.9,146.41l72.19-65.99c-.89-1.04-1.77-2.08-2.68-3.1l-72.13,65.94c.91,1.02,1.78,2.07,2.62,3.15Z"
      />
      <path
        className="st0"
        d="M242.21,142.09l66.18-72.05c-.89-.88-1.8-1.74-2.72-2.59l-66.08,71.94c.9.87,1.76,1.78,2.62,2.7Z"
      />
      <path
        className="st0"
        d="M238.15,138.08l59.67-77.58c-.88-.72-1.79-1.4-2.68-2.11l-59.54,77.4c.88.72,1.71,1.51,2.55,2.28Z"
      />
      <path
        className="st0"
        d="M233.74,134.41l52.68-82.47c-.84-.58-1.7-1.15-2.55-1.71l-52.59,82.33c.85.58,1.65,1.22,2.47,1.84Z"
      />
      <path
        className="st0"
        d="M229.01,131.12l45.28-86.73c-.79-.45-1.57-.93-2.37-1.36l-45.25,86.67c.79.46,1.57.93,2.34,1.42Z"
      />
      <path
        className="st0"
        d="M223.98,128.23l37.54-90.34c-.72-.33-1.45-.66-2.18-.98l-37.52,90.28c.72.34,1.45.67,2.15,1.04Z"
      />
      <path
        className="st0"
        d="M218.69,125.78l29.53-93.26c-.64-.23-1.29-.44-1.94-.66l-29.51,93.21c.64.24,1.29.45,1.93.7Z"
      />
      <path
        className="st0"
        d="M213.17,123.8l21.28-95.47c-.55-.14-1.11-.25-1.66-.38l-21.27,95.43c.55.15,1.11.26,1.66.43Z"
      />
      <path
        className="st0"
        d="M220.33,25.41c-.45-.07-.89-.17-1.34-.24l-12.88,96.92c.45.08.9.14,1.34.24l12.88-96.92Z"
      />
      <path
        className="st0"
        d="M205.98,23.74c-.34-.02-.68-.05-1.02-.08l-4.38,97.59c.34.03.67.11,1.02.15l4.38-97.67Z"
      />
      <path
        className="st0"
        d="M132.75,211.95l-86.88,45.04c.73,1.54,1.51,3.06,2.29,4.58l86.74-44.97c-.77-1.52-1.51-3.06-2.16-4.64Z"
      />
      <path
        className="st0"
        d="M135.16,217.12l-82.62,52.44c.81,1.38,1.63,2.74,2.47,4.09l82.51-52.37c-.83-1.36-1.63-2.73-2.36-4.16Z"
      />
      <path
        className="st0"
        d="M138.02,222.09l-77.73,59.44c.86,1.21,1.7,2.43,2.59,3.61l77.65-59.37c-.87-1.2-1.71-2.42-2.5-3.67Z"
      />
      <path
        className="st0"
        d="M141.31,226.83l-72.26,65.99c.88,1.04,1.77,2.08,2.68,3.1l72.15-65.89c-.89-1.04-1.74-2.11-2.57-3.2Z"
      />
      <path
        className="st0"
        d="M145.02,231.28l-66.25,72.05c.89.88,1.81,1.73,2.72,2.59l66.1-71.9c-.9-.88-1.73-1.82-2.57-2.75Z"
      />
      <path
        className="st0"
        d="M149.12,235.42l-59.72,77.56c.88.73,1.78,1.42,2.67,2.12l59.59-77.38c-.88-.73-1.69-1.53-2.53-2.3Z"
      />
      <path
        className="st0"
        d="M153.6,239.2l-52.72,82.45c.84.58,1.69,1.16,2.54,1.73l52.65-82.33c-.84-.59-1.66-1.22-2.47-1.85Z"
      />
      <path
        className="st0"
        d="M158.42,242.6l-45.33,86.71c.79.45,1.57.93,2.37,1.36l45.3-86.65c-.79-.46-1.57-.93-2.34-1.42Z"
      />
      <path
        className="st0"
        d="M163.55,245.57l-37.59,90.32c.72.33,1.45.66,2.18.98l37.57-90.27c-.72-.34-1.45-.67-2.15-1.04Z"
      />
      <path
        className="st0"
        d="M168.96,248.08l-29.57,93.24c.64.23,1.29.44,1.94.66l29.56-93.19c-.64-.24-1.29-.45-1.93-.7Z"
      />
      <path
        className="st0"
        d="M174.6,250.1l-21.33,95.46c.55.14,1.11.25,1.66.38l21.32-95.42c-.55-.15-1.11-.26-1.66-.43Z"
      />
      <path
        className="st0"
        d="M167.52,348.5c.45.07.89.17,1.34.24l12.93-96.92c-.45-.08-.9-.12-1.35-.21l-12.92,96.9Z"
      />
      <path
        className="st0"
        d="M182.01,350.16c.34.02.68.06,1.02.08l4.43-97.59c-.34-.03-.68-.08-1.02-.12l-4.43,97.63Z"
      />
      <path
        className="st0"
        d="M183.46,23.62h0c-2.31.16-4.61.3-6.89.54l.62,14.77-1.9-14.6c-4.21.48-8.38,1.11-12.49,1.9l2.37,18.22-3.95-17.94c-4.04.82-8.01,1.82-11.94,2.93l4.73,21.49-6.57-20.96c-3.84,1.13-7.62,2.39-11.33,3.79l7.68,24.49-9.76-23.67c-3.61,1.42-7.18,2.93-10.66,4.59l11.18,27.12-13.47-25.98c-3.37,1.68-6.67,3.47-9.91,5.37l15.19,29.29-17.67-27.84c-3.11,1.9-6.14,3.93-9.11,6.03l19.67,30.99-22.28-29.14c-2.84,2.09-5.62,4.27-8.32,6.54l24.57,32.13-27.23-29.82c-2.57,2.25-5.08,4.56-7.51,6.96l29.84,32.67-32.52-29.9c-2.29,2.38-4.5,4.82-6.64,7.34l35.36,32.51-38.04-29.29c-2,2.48-3.92,5.02-5.78,7.61l41.09,31.64-43.71-27.95c-1.72,2.54-3.34,5.15-4.92,7.79l46.97,30.04-49.4-25.82c-1.44,2.58-2.82,5.2-4.12,7.86l52.87,27.64-55.05-22.91c-1.16,2.59-2.26,5.21-3.29,7.87l58.68,24.42-60.59-19.22c-.9,2.57-1.73,5.17-2.5,7.8l64.33,20.4-65.91-14.73c-.64,2.53-1.23,5.08-1.75,7.65l69.79,15.6-70.89-9.45c-.4,2.46-.74,4.94-1.03,7.43l74.84,9.98-75.46-3.42c-.18,2.37-.31,4.76-.39,7.16l79.43,3.6-79.53,3.34c.02,2.28.06,4.57.17,6.83l83.55-3.51-83,10.78c.21,2.16.47,4.3.76,6.44l86.97-11.3-85.76,18.86c.37,2.02.77,4.03,1.22,6.02l89.69-19.73-87.76,27.51c.51,1.87,1.03,3.74,1.6,5.58l91.64-28.72-88.92,36.66c.63,1.71,1.31,3.4,2,5.08l90.32-37.24c-.66-1.64-1.29-3.29-1.83-4.99-.01-.05-.04-.09-.05-.14-.51-1.63-.91-3.31-1.29-4.99-.04-.17-.09-.33-.13-.5-.34-1.54-.58-3.12-.81-4.7-.04-.29-.09-.57-.13-.86-.19-1.44-.32-2.89-.41-4.36-.03-.41-.04-.82-.06-1.23-.05-1.01-.15-2.01-.15-3.03,0-.33.04-.65.05-.98,0-.53.06-1.06.08-1.59.05-1.22.07-2.44.18-3.64.06-.65.16-1.28.24-1.93.13-1.09.31-2.17.49-3.24.13-.75.22-1.52.38-2.26.2-.96.49-1.89.73-2.83.22-.85.41-1.72.66-2.56.25-.82.55-1.62.82-2.43.32-.94.66-1.88,1.03-2.8.27-.69.53-1.39.83-2.06.44-1.02.95-2.01,1.44-3,.28-.56.52-1.14.82-1.69.58-1.08,1.23-2.12,1.86-3.16.27-.44.52-.88.8-1.32.72-1.13,1.48-2.22,2.27-3.3.24-.33.48-.65.72-.97.88-1.16,1.77-2.29,2.72-3.39.19-.22.4-.43.59-.65,1.04-1.17,2.09-2.32,3.2-3.41.13-.13.28-.25.42-.38,1.21-1.16,2.42-2.31,3.71-3.37.06-.05.14-.1.2-.15,1.36-1.11,2.78-2.15,4.22-3.16.02-.01.03-.03.05-.04,1.43-.99,2.92-1.9,4.43-2.77.11-.06.21-.13.32-.2,1.43-.82,2.89-1.56,4.38-2.27.21-.1.41-.2.61-.3,1.41-.65,2.83-1.25,4.29-1.81.3-.12.61-.23.92-.34,1.37-.5,2.75-.98,4.16-1.39.41-.12.82-.21,1.23-.32,1.33-.36,2.64-.74,4-1.01.51-.1,1.03-.14,1.54-.24,1.55-.28,3.11-.55,4.7-.72.31-.03.63-.04.94-.06,0,0,.01,0,.02,0,.11,0,.23,0,.34-.02h0V23.38c-.76.03-1.52.02-2.27.06-.89.05-1.73.1-2.48.18Z"
      />
    </g>
    <g>
      <rect
        className="st0"
        height="114.54"
        width="17.87"
        x="459.15"
        y="125.52"
      />
      <polygon
        className="st0"
        points="611.87 211.65 542.38 125.37 524.51 125.37 524.51 240.06 542.38 240.06 542.38 153.77 611.87 240.06 629.58 240.06 629.58 125.37 611.87 125.37 611.87 211.65"
      />
      <rect
        className="st0"
        height="114.54"
        width="17.87"
        x="773.6"
        y="125.52"
      />
      <rect
        className="st0"
        height="114.54"
        width="17.87"
        x="1025.76"
        y="125.52"
      />
      <path
        className="st0"
        d="M1139.69,122.93c-33.75,0-59.56,26.73-59.56,59.56s25.81,60.17,59.56,60.17,59.56-27.34,59.56-60.17-25.81-59.56-59.56-59.56ZM1139.69,225.71c-23.21,0-40.47-19.7-40.47-43.22s17.26-42.61,40.47-42.61,40.47,19.09,40.47,42.61-17.26,43.22-40.47,43.22Z"
      />
      <polygon
        className="st0"
        points="1322.35 125.37 1322.35 211.65 1252.86 125.37 1234.99 125.37 1234.99 240.06 1252.86 240.06 1252.86 153.77 1322.35 240.06 1340.06 240.06 1340.06 125.37 1322.35 125.37"
      />
      <path
        className="st0"
        d="M856.81,217.16v-91.63h-17.82v96.36c0,9.04,7.1,18.15,18.3,18.15h45.07l1.45-17.1h-41.35c-3.15,0-5.65-2.24-5.65-5.79Z"
      />
      <path
        className="st0"
        d="M675.77,143.69v96.36h17.82v-50.54h38.55l1.64-17.14h-40.19v-23.95c0-3.55,2.51-5.79,5.65-5.79h41.35v-17.1h-46.53c-11.2,0-18.3,9.12-18.3,18.15Z"
      />
      <path
        className="st0"
        d="M950.09,217.16v-91.63h-17.82v96.36c0,9.04,7.1,18.15,18.3,18.15h45.07l1.45-17.1h-41.35c-3.15,0-5.65-2.24-5.65-5.79Z"
      />
    </g>
  </svg>
);

export default InfillionLogo;
